// OPTIONS HEDGING · the full readiness matrix (Advanced / Diagnostics): every key an option order of
// the chosen environment needs, with its value; activation switches apart from blockers; option
// quantity verification. Traders see the one-line "System ready" summary instead.
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

const btn = "px-2 py-1 rounded-sm text-xs font-bold border";

function Pill({ cls, children, testId }) {
  return <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-sm ${cls || "bg-[var(--term-s3)]"}`} data-testid={testId}>{children}</span>;
}

export default function ReadinessDetails({ initialEnv = "SHADOW", autoLoad = true }) {
  const [r, setR] = useState(null);
  const [und, setUnd] = useState("");
  const [env, setEnv] = useState(initialEnv);
  const load = (e = env) => api.get("/options-hedge/readiness", { params: { environment: e } }).then((x) => setR(x.data)).catch((err) => toast.error(apiError(err)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (autoLoad) load(initialEnv); }, []);
  const verify = async () => {
    try { const x = await api.post("/options-hedge/readiness/verify-quantity", { underlying: und }); toast.success(`${x.data.underlying}: lot ${x.data.proposed_broker_quantity} x ${x.data.units_per_quantity} verified`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="term-panel rounded-sm p-3 text-xs space-y-2" data-testid="hedge-readiness">
      <div className="flex items-center gap-2 flex-wrap">
        <b>Readiness</b>
        <select className="bg-[var(--term-input)] border border-[var(--term-border-strong)] rounded-sm px-1.5 py-0.5" value={env}
          onChange={(e) => { setEnv(e.target.value); load(e.target.value); }} data-testid="hedge-readiness-env">
          <option value="SHADOW">SHADOW</option><option value="LIVE">LIVE</option></select>
        <button className={btn} onClick={() => load()} data-testid="hedge-readiness-btn">Check again</button>
        {r && <Pill cls={r.ready ? "bg-[#00C805]/15 text-[#008a04]" : "bg-[#FFCC00]/20 text-[#9a7200]"} testId="hedge-readiness-verdict">
          {r.ready ? (r.activation_pending?.length ? `READY · ${r.environment} activation pending: ${r.activation_pending.join(", ")}` : `READY · ${r.environment} active`)
            : `NOT READY: ${r.blocking.join(", ")}`}</Pill>}
      </div>
      {r && <>
        <table className="w-full"><tbody>{r.checks.map((c) => (
          <tr key={c.check} className="border-t border-[var(--term-border)]">
            {/* a passed check with a warning is ⚠, never a plain ✓ (UI/UX audit Phase 5) */}
            <td className={`px-1.5 font-bold ${c.ok && c.warning ? "text-[#9a7200]" : c.ok ? "text-[#00C805]" : c.activation_switch ? "text-[#9a7200]" : "text-[#FF3B30]"}`}
              title={c.warning || undefined} data-testid={`readiness-mark-${c.check}`}>{c.ok && c.warning ? "⚠" : c.ok ? "✓" : c.activation_switch ? "switch" : "✗"}</td>
            <td className="px-1.5 mono">{c.check}</td>
            <td className="px-1.5 mono text-[10px] text-[var(--term-muted)]">{c.warning && <b className="text-[#9a7200]">{c.warning} · </b>}
              {c.detail == null ? "" : typeof c.detail === "string" ? c.detail : JSON.stringify(c.detail)}</td>
          </tr>))}</tbody></table>
        <div className="flex items-center gap-2">
          <input className="bg-[var(--term-input)] border border-[var(--term-border-strong)] rounded-sm px-2 py-1 w-32" placeholder="Underlying" value={und}
            onChange={(e) => setUnd(e.target.value.toUpperCase())} data-testid="hedge-verify-underlying" />
          <button className={`${btn} border-[#2563EB] text-[#2563EB]`} disabled={!und} onClick={verify} data-testid="hedge-verify-btn">Verify option quantity</button>
          <span className="text-[10px] text-[var(--term-muted)]">broker master lot + units from the read-only margin calculator</span>
        </div>
      </>}
    </div>
  );
}
